import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  Paragraph,
  AbsoluteCTA,
  BackgroundContent,
} from 'components';

const Process = () => (
  <div className={'machine-learning__process'}>
    <Section color={'pigeon-post'}>
      <Row className={'no-gap anim-fade-in-bottom'}>
        <Col sm={12} md={6}>
          <SectionHeader size={'big'} color={'white'} headingType={2}>
            Process
          </SectionHeader>
        </Col>
        <Col sm={12} md={6}>
          <div className={'machine-learning__process-description'}>
            <Heading color={'white'} size={'medium-plus'} type={3}>
              AI, machine learning and deep neural networks can help you with a
              number of problems
            </Heading>
            <Paragraph
              additionalClass={'text--light'}
              color={'white'}
              size={'medium'}
            >
              Artificial intelligence, machine learning and data science can
              help you solve a variety of business problems. Here are some
              examples of applications:
            </Paragraph>
          </div>
        </Col>
      </Row>
    </Section>
    <Section
      fullwidth
      spaceless
      additionalClass={'machine-learning__process-content'}
    >
      <div className={'w-container'}>
        <div className={'machine-learning__process-items'}>
          <Row className={'no-gap anim-fade-in-bottom'}>
            <Col sm={6} md={4}>
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'1'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Analyze the customer churn or predict the market demand.'
                  }
                  headingType={3}
                >
                  Predicting what will happen to your product
                </SectionHeader>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'2'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Find patterns and segment your customers to allow better targeting.'
                  }
                  headingType={3}
                >
                  Clustering your customer data
                </SectionHeader>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'3'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Detect faces, people, objects, and actions, or measure objects.'
                  }
                  headingType={3}
                >
                  Obtaining information from images
                </SectionHeader>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'4'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Detect fraud, malfunctions or security incidents.'
                  }
                  headingType={3}
                >
                  Detecting anomalies
                </SectionHeader>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'5'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Detect natural phenomena from passive and active remote sensors.'
                  }
                  headingType={3}
                >
                  Environment
                </SectionHeader>
              </div>
            </Col>
            <Col
              sm={6}
              md={4}
              className={'machine-learning__process-item-wrapper'}
            >
              <div className={'machine-learning__process-item'}>
                <BackgroundContent content={'6'} color={'pigeon-post'} />
                <SectionHeader
                  size={'tiny-plus'}
                  description={
                    'Employ smart chatbots to automate your sales processes and improve the customer experience.'
                  }
                  headingType={3}
                >
                  Workforce automation
                </SectionHeader>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <AbsoluteCTA id={'page-machine-learning-process'} />
    </Section>
  </div>
);

export default Process;
